export default __webpack_public_path__ + "static/media/coming-soon-icon.21d8010a.svg";